import { cn } from "@/lib/utils";

/**
 * The three widths of a `Dialog`: `md` (640px) a form, `lg` (880px) a picker or an editor with a
 * side column, `xl` (1120px) a detail with a table and a side pane (a preview, a pass). The body
 * scrolls; the header and the footer stay in view.
 */
export const DIALOG_SIZES = { md: "max-w-[640px]", lg: "max-w-[880px]", xl: "max-w-[1120px]" } as const;

export type DialogSize = keyof typeof DIALOG_SIZES;

export const dialogClass = (size: DialogSize, className?: string) => cn("flex max-h-[90dvh] w-[calc(100vw-2rem)] flex-col gap-4", DIALOG_SIZES[size], className);
